
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"20","cy":"20","r":"20","fill":"#E73273"}}),_c('path',{attrs:{"fill":"#FFF","fill-rule":"nonzero","d":"M22.09 20L28 25.91 25.91 28 20 22.09 14.09 28 12 25.91 17.91 20 12 14.09 14.09 12 20 17.91 25.91 12 28 14.09 22.09 20z"}})])])
          )
        }
      }
    